'use client';
/**
 * nav-live(2026-10-24) — 지역 기억 동기화(화면 없음 · null 렌더).
 *
 * 왜: 헤더 지역 칩(GlobalRegionChip masthead)을 걷어내고 그 자리에 방문자 카운터를 넣었다(Node 요청).
 *   그 칩이 «주 칩» 으로서 하던 일 하나가 다른 곳에 없었다 —
 *   지역 허브(/apt/region/{시도} · /apt/area/…)에 들어오면 지역 기억(kd_nav_region_v1)을 그 지역으로 맞추는 것
 *   (→ 홈 지역 필터·검색 시트·/calendar 지역 칩이 같은 지역을 본다 · nav_region1 v2 (9)).
 *   이 기능만 그대로 옮겼다. 규칙도 그대로: 허브 경로일 때만 · 값이 같으면 아무것도 안 함 · 현장 상세는 기억을 바꾸지 않음.
 * ⛔ 서버 HTML 에 아무것도 내지 않는다(방문자 무관). 수화 뒤 useEffect 에서만 localStorage 를 만진다.
 */
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useNavData } from './nav-data-context';
import { currentScope, readRegionMemory, writeRegionMemory } from '@/lib/nav/region-scope';
import { isRegionHubPath } from '@/lib/nav/geo-suggest';

/** GlobalRegionChip REGION_MEMORY_EVENT 와 같은 값(칩 모듈·CSS 를 끌어오지 않으려고 문자열로 둔다). */
const REGION_MEMORY_EVENT = 'kd:region-memory';

export default function RegionMemorySync() {
  const pathname = usePathname();
  const { headerRegion, navV2 } = useNavData();
  useEffect(() => {
    if (!navV2 || !headerRegion || !isRegionHubPath(pathname)) return;
    try {
      const mem = readRegionMemory();
      const cur = currentScope(headerRegion, pathname, window.location.search, mem);
      if (cur.source === 'path' && cur.node && mem !== cur.node.code) {
        writeRegionMemory(cur.node.code, cur.node);
        window.dispatchEvent(new Event(REGION_MEMORY_EVENT));
      }
    } catch { /* 저장소 막힘 — 기억 없이 동작 */ }
  }, [pathname, headerRegion, navV2]);
  return null;
}
